import { installEarlyErrorCapture } from './sentryLazy'

// T2899: prvi uvoz v `main.tsx` — lovilec zgodnjih napak je priklopljen, preden
// se izvedejo ostali moduli vstopnega grafa (ESM jih izvede po vrsti uvozov).
installEarlyErrorCapture()
